export default "__VITE_ASSET__DGZdsKXc__"